import { actions } from '@client/monolith/legacy/store/account/orderpay/actions';
import { getters } from '@client/monolith/legacy/store/account/orderpay/getters';
import { mutations } from '@client/monolith/legacy/store/account/orderpay/mutations';
import { GetOrderPayAccountData } from '@ankorstore/api-internal/data-contracts';

export interface InitialState {
  status: GetOrderPayAccountData['data'] | null;
}

const initialState: InitialState = {
  status: null,
};

export default {
  namespaced: true,
  state: { ...initialState },
  actions,
  mutations,
  getters,
};
